var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"vs-navbar--item",class:[{'is-active-item': _vm.isActiveItem}, `vs-navbar-item-${_vm.getActiveTextColor}`],style:([_vm.styleHover]),on:{"click":function($event){return _vm.clickItem()},"mouseout":_vm.mouseout,"mouseover":_vm.mouseover}},[_vm._t("default"),_c('span',{staticClass:"vs-navbar-after",style:([_vm.styleAfter])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }